import { useState } from 'react';

/**
 * 年月（YYYY-MM）の形。
 * @graph-connects none
 */
const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

/**
 * 年月の入力欄。打っている間は手元の下書きだけを変え、欄を離れるか Enter で確定したときに、
 * 値が年月として正しく、今の値と違えば1回だけ保存する（途中の文字や、選ぶたびの保存を送らない）。
 * 保存には打ち始めた時点の値を添える（その間に他の人が変えていれば、保存側が競合として扱う）。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題の目標時期を、確定したときに年月として正しい値だけ1回保存する入力欄
 * @graph-connects none
 */
export function MonthField({
  label,
  value,
  disabled,
  className,
  onSave,
}: {
  label: string;
  value: string | null;
  disabled: boolean;
  className: string;
  onSave: (next: string | null, base: string | null) => void;
}) {
  const [edit, setEdit] = useState<{ base: string | null; draft: string } | null>(null);

  const commit = () => {
    if (edit === null) return;
    setEdit(null);
    const next = edit.draft === '' ? null : edit.draft;
    if (next !== null && !MONTH_RE.test(next)) return;
    if (next === edit.base) return;
    onSave(next, edit.base);
  };

  return (
    <input
      type="month"
      aria-label={label}
      className={className}
      disabled={disabled}
      value={edit?.draft ?? value ?? ''}
      onChange={(e) => {
        setEdit({ base: edit?.base ?? value, draft: e.target.value });
      }}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
      }}
    />
  );
}
